import { graphql } from '@/client/services/api/graphql/gql';

export const listExpertsQuery = graphql(`
  query ListExperts(
    $enabled: BooleanQueryOperatorArgs
    $includeTotalCount: Boolean! = false
    $name: StringQueryOperatorArgs
    $ordering: [OrderBy!]
    $page: Int! = 0
    $pageSize: Int! = 50
  ) {
    listExperts(
      enabled: $enabled
      includeTotalCount: $includeTotalCount
      name: $name
      ordering: $ordering
      page: $page
      pageSize: $pageSize
    ) {
      limitInfo {
        limit
        totalCurrentCount
        __typename
      }
      pageInfo {
        totalCount
      }
      edges {
        node {
          color
          companyId
          creatorId
          description
          enabled
          id
          name
          negativeFeedback
          positiveFeedback
          resources {
            addedBy
            extensionName
            extensionType
            id
            path
            source
            sourceId
            isFolder
            parentFolder
            lastSynced
            lastSyncSuccessful
            lastSyncErrorMessage
            __typename
          }
          resourcesCount
          responses
          segmentation {
            segmentationId
            segmentationType
            __typename
          }
        }
      }
    }
  }
`);
